export default __webpack_public_path__ + "static/media/ACTIVITY_LOG.b2524e4a.svg";